import axios from "axios";

import {showCorrectPrice, calculateMealCount} from ".";
import {disableCheckout, activateNextStep, disableAddMore} from "./flow";

/**
 * updates the visual meal plan chart / calculator
 *
 * @async
 * @param {object} c - the response from the attached cart
 * @returns {*}
 */
export const hydrateCalculator = async (c, id) => {
  try {
    const response = await axios.get(window.Shopify.routes.root + "cart.js");
    const res = await response;

    if (res.status !== 200) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    const items = res.data.items;

    // console.log("Hydrating sidecart... | data: ", items);

    const mealCount = calculateMealCount(items);

    // open mini cart everytime its updated (mobile)

    // if (items.length > 0) {
    //   const miniCartPdp = document.querySelector(".mini-cart-pdp");
    //   if (miniCartPdp) {
    //     miniCartPdp.classList.remove("visually-hidden", "closed");
    //   }
    // }

    if (document.querySelector("#meal-plan-title")) {
      const title = document
        .querySelector("#meal-plan-title")
        .getAttribute("data-title");
      document.querySelector(
        "#meal-plan-title",
      ).innerHTML = `${mealCount} ${title}`;
    }

    if (document.querySelector("#meal-plan-title-addons")) {
      const addonTitle = document
        .querySelector("#meal-plan-title-addons")
        .getAttribute("data-title");
      document.querySelector(
        "#meal-plan-title-addons",
      ).innerHTML = `${mealCount} ${addonTitle}`;
    }

    if (document.querySelector("[kind=pdp]")) {
      document
        .querySelector("[kind=pdp]")
        .setAttribute("data-count", mealCount);
    }

    // sync the continue button disabled state whena dding a newe item (not adjusting)
    if (mealCount >= 4) {
      if (document.querySelector(`[data-modal-id="modal-payment-options"]`)) {
        document
          .querySelectorAll(`[data-modal-id="modal-payment-options"]`)
          .forEach((el) => {
            el.classList.remove("disabled");
          });
      }
    } else {
      if (document.querySelector(`[data-modal-id="modal-payment-options"]`)) {
        document
          .querySelectorAll(`[data-modal-id="modal-payment-options"]`)
          .forEach((el) => {
            el.classList.add("disabled");
          });
      }
    }

    // Update every data targeted div with the updated meal count
    document.querySelectorAll(`[data-total-meal-count]`).forEach((el) => {
      el.innerHTML = mealCount;
    });

    if (document.querySelector(`[data-modal-id="modal-payment-options"]`)) {
      document
        .querySelectorAll(
          `[data-modal-id="modal-payment-options"] .meal-plan-cart-cta__counter`,
        )
        .forEach((el) => {
          el.innerHTML = mealCount;
        });
    }

    if (document.querySelector("#current-bar")) {
      document
        .querySelector("#current-bar")
        .setAttribute("data-amount", mealCount);
    }

    hydrateBar(mealCount);
    hydratePrice(id);
    if (document.querySelector("#cc")) {
      document.querySelector("#cc").classList.remove("visually-hidden");
    }
  } catch (err) {
    console.log(err);
  }
};

/**
 * fetch to updated cart and run function life cycle
 *
 * @async
 * @param {object} c
 * @returns {object}
 */
export const hydrateAddons = async (c) => {
  try {
    const response = await axios.get(window.Shopify.routes.root + "cart.js");
    const res = await response;

    if (res.status !== 200) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    console.log("refreshed cart (addons): ", res.data);

    let _count = 0;

    let _data = res.data.items.filter((i) => {
      if (i.product_type == "Addon") {
        _count = _count + i.quantity;
        return i;
      }
    });

    // document.querySelector("#addons-header-wrapper").classList.remove("visually-hidden");
    document.querySelector(
      "#addons-meal-count-title",
    ).innerHTML = `${_count} ${window.mealPlan.addOns.title}`;
    document
      .querySelector("[kind=pdp-addon]")
      .setAttribute("data-count", _count);
    document.querySelectorAll(`[data-total-addons-count]`).forEach((el) => {
      el.innerHTML = _count;
    });

    addOnsNextStep(_count);

    hydrateAddonsPrice();
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const addOnsNextStep = (count) => {
  const next_step = document.querySelector("#addons-next-step");

  if (!next_step) return;

  if (count === 0) {
    next_step.innerHTML = `${window.mealPlan.addOns.proceed_to_checkout_without_add_ons}`;
  } else {
    next_step.innerHTML = `${window.mealPlan.addOns.proceed_to_checkout}`;
  }
};

/**
 * update the mini side cart content on the meal plans page
 *
 * @async
 * @returns {Object}
 */
export const hydratePrice = async (id) => {
  let _url = window.location.pathname;

  if (document.querySelector("#mini-cart-loader")) {
    document
      .querySelector("#mini-cart-loader")
      .classList.remove("visually-hidden");
  }

  try {
    const response = await axios.get(
      window.Shopify.routes.root + "cart?view=total",
    );
    const res = await response;

    if (res.status !== 200) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    let p = new DOMParser();
    let doc = p.parseFromString(res.data, "text/html");

    let _total = doc.querySelector("#updated-cart-total").innerHTML;

    let _forced_total = doc.querySelector(
      "#updated-cart-total-forced-discount",
    ).innerHTML;

    let _discount = doc.querySelector(
      "#updated-cart-total-pre-discount",
    ).innerHTML;
    let _items = doc.querySelector("#updated-cart-items").innerHTML;
    const mealPlanTotal = document.querySelector("#meal-plan-total");
    const otpTotal = document.querySelector("#otp-total-price");
    const subTotal = document.querySelectorAll(
      "[js-meal-plan='subscription-total-price']",
    );
    const subWithDiscount = document.querySelector("#sub-with-discount");
    const addonsMealTotal = document.querySelector("#addons-meal-totals");
    const mealPlanCartItems = document.querySelector("#meal-plan-cart-items");
    const mealPlanCta = document.querySelector(".meal-plan-cart-cta__total");

    if (mealPlanTotal) {
      mealPlanTotal.innerHTML = _forced_total;
      mealPlanCta.textContent = _forced_total;
    }
    if (otpTotal) {
      otpTotal.innerHTML = _discount;
    }
    if (subTotal) {
      subTotal.forEach((el) => {
        el.innerHTML = _discount;
      });
    }
    if (subWithDiscount) {
      subWithDiscount.innerHTML = _total;
    }
    if (addonsMealTotal) {
      addonsMealTotal.innerHTML = _total;
    }
    if (mealPlanCartItems) {
      mealPlanCartItems.innerHTML = _items;
    }

    let newCount = doc.querySelector(`#mini-cart-item-${id}`)
      ? doc.querySelector(`#mini-cart-item-${id}`).getAttribute("data-quantity")
      : null || null;

    if (document.querySelector(`#popup-mpa-${id}`)) {
      document
        .querySelector(`#popup-mpa-${id}`)
        .setAttribute("data-quantity", newCount);
    }

    if (document.querySelector(`#popup-mpa-${id} #adjusted-cart-amount`)) {
      document.querySelector(
        `#popup-mpa-${id} #adjusted-cart-amount`,
      ).innerHTML = newCount;
    }

    if (_url.includes("/products/")) {
      // let newCount = doc
      //   .querySelector(`#mini-cart-item-${id}`)
      //   .getAttribute("data-quantity");
      // document
      //   .querySelector(`#popup-mpa-${id}`)
      //   .setAttribute("data-quantity", newCount);
      // document.querySelector(
      //   `#popup-mpa-${id} #adjusted-cart-amount`,
      // ).innerHTML = newCount;

      // Leaving this here to retain what is was before incase it needs to revert

      return;
    } else {
      let _spinner = `
        <div id="mini-cart-loader" class="loader-indicator visually-hidden">
          <span class="spinner"></span>
        </div>
      `;

      if (mealPlanCartItems) {
        mealPlanCartItems.insertAdjacentHTML("afterbegin", _spinner);
      }

      if (document.querySelector("#mini-cart-loader")) {
        document
          .querySelector("#mini-cart-loader")
          .classList.add("visually-hidden");
      }
    }

    showCorrectPrice();

    return res;
  } catch (err) {
    console.log(err);
  }
};

/**
 * update the addons mini cart price and content - different to hydratePrice for easier management
 *
 * @async
 * @returns {*}
 */
export const hydrateAddonsPrice = async () => {
  try {
    const response = await axios.get(
      window.Shopify.routes.root + "cart?view=total",
    );
    const res = await response;

    if (res.status !== 200) {
      throw new Error(`Request failed with status ${res.status}`);
    }

    let p = new DOMParser();
    let doc = p.parseFromString(res.data, "text/html");
    let _total = doc.querySelector("#updated-cart-total-addons").innerHTML;
    let _items = doc.querySelector("#updated-cart-items-addons").innerHTML;
    let _meal_count = doc.querySelector(
      "#updated-cart-meal-count-addons",
    ).innerHTML;

    let formattedTotal = _total.replace("+", "");

    document.querySelectorAll(`[data-total-addons-price]`).forEach((el) => {
      el.innerHTML = formattedTotal;
    });

    document.querySelector("#addons-meal-count-title").innerHTML = _meal_count;
    document.querySelector("#meal-plan-cart-items-addons").innerHTML = _items;

    if (_meal_count == "0 Addons Added" || _meal_count == "0") {
      if (document.querySelector("#meal-plan-addons-cart-cta")) {
        document.querySelector("#meal-plan-addons-cart-cta").innerHTML =
          "Checkout without Addons";
      }
    } else {
      if (document.querySelector("#addons-header-wrapper")) {
        document
          .querySelector("#addons-header-wrapper")
          .classList.remove("visually-hidden");
      }

      if (document.querySelector("#meal-plan-addons-cart-cta")) {
        document.querySelector("#meal-plan-addons-cart-cta").innerHTML =
          "Checkout";
      }
    }

    let _spinner = ` <div id="mini-cart-loader-addons" class="loader-indicator visually-hidden">
    <span class="spinner"></span>
  </div>`;

    document
      .querySelector("#meal-plan-cart-items-addons")
      .insertAdjacentHTML("afterbegin", _spinner);
    // document
    //   .querySelector("#mini-cart-loader-addons")
    //   .classList.add("visually-hidden");

    showCorrectPrice();
  } catch (err) {
    console.log(err);
  }
};

const updateButtonDiffText = (n) => {
  // NOTE: @sid Temp patch to handle the button text update
  // TODO: @sid remove this function as it should be handled in the checkout-button.js file
  const buttonStates = {
    default: window?.mealPlan?.mealPlan?.add_more_label,
    updating: "Updating...",
    updated: window?.mealPlan?.mealPlan?.proceed_to_addons,
  };

  const checkoutButton = document.querySelector("#meal-plan-cart-cta");
  const mobileCheckoutButton = document.querySelector("#mob-next-step");

  if (!checkoutButton) return;
  if (!mobileCheckoutButton) return;

  const count = n;
  const counterHTML = `<span class="meal-plan-cart-cta__counter">${count}</span>`;
  const totalHTML = `<span class="meal-plan-cart-cta__total"><div class="price-loader"></div></span>`;

  let diff = 4 - n;
  const content = buttonStates.default.replace("[count]", diff);
  checkoutButton.innerHTML = `${counterHTML} ${content} ${totalHTML}`;
  mobileCheckoutButton.innerHTML = `${counterHTML} ${content}`;
};

const defaultButtonText = (n) => {
  const buttonStates = {
    default: window?.mealPlan?.mealPlan?.add_more_label,
    updating: "Updating...",
    updated: window?.mealPlan?.mealPlan?.proceed_to_addons,
  };

  const checkoutButton = document.querySelector("#meal-plan-cart-cta");
  const mobileCheckoutButton = document.querySelector("#mob-next-step");

  if (!checkoutButton) return;
  if (!mobileCheckoutButton) return;

  const count = n;
  const counterHTML = `<span class="meal-plan-cart-cta__counter">${count}</span>`;
  const totalHTML = `<span class="meal-plan-cart-cta__total"><div class="price-loader"></div></span>`;

  let diff = 4 - n;
  const content = buttonStates.updated;
  checkoutButton.innerHTML = `${counterHTML} ${content} ${totalHTML}`;
  mobileCheckoutButton.innerHTML = `${counterHTML} ${content}`;
};

/**
 * updates the position of the current meal plans selected tracker - relative to the visual chart / calculator
 *-
 * @param {Number} n
 */
export const hydrateBar = (n) => {
  let _url = window.location.pathname;

  if (_url.includes("/products/")) {
    return false;
  }

  let _n = parseInt(n);

  // if _m is below 4, we dont need to do anything
  if (_n < 4) {
    updateButtonDiffText(_n);
    disableCheckout();
  }

  // if _n is 4 or more, we can move to the next step
  if (_n >= 4 && _n < 18) {
    defaultButtonText(_n);
    activateNextStep(_n);
  }

  // if _n is 18 or more, we can move to the next step but also disable the add more button
  if (_n >= 18) {
    disableAddMore();
  }
};
